var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_19026)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.843 84.8274L92.843 83.1974L85.843 81.5474L84.153 75.0974L82.373 81.5374L75.373 83.1874L82.373 84.8174L84.153 91.6074L85.843 84.8274Z",
    fill: "#F89358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3423 37.5422L46.4323 36.5422L42.2823 35.5422L41.2823 31.7422L40.2823 35.5422L36.1523 36.5722L40.2423 37.5722L41.2423 41.5722L42.3423 37.5422Z",
    fill: "#FFB762"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9638 94.6374L62.1038 100.847C61.7046 101.064 61.2578 101.177 60.8038 101.177C60.3498 101.177 59.903 101.064 59.5038 100.847L49.6238 94.8474C49.2477 94.6472 48.9417 94.3369 48.7469 93.958C48.5521 93.5791 48.4777 93.1497 48.5338 92.7274L56.3338 44.2974C56.4465 43.7579 56.7461 43.2755 57.1796 42.9352C57.6132 42.595 58.153 42.4187 58.7038 42.4374H63.8038C64.3539 42.417 64.8933 42.5929 65.3256 42.9337C65.7579 43.2744 66.055 43.7578 66.1638 44.2974L73.0838 92.2974C73.1474 92.7543 73.0751 93.2198 72.8759 93.6359C72.6768 94.052 72.3596 94.4003 71.9638 94.6374Z",
    fill: "#08A636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1338 94.5072L63.6138 99.8672C63.2857 100.073 62.9062 100.182 62.5188 100.182C62.1314 100.182 61.7519 100.073 61.4238 99.8672L52.9038 94.5072C52.5733 94.2976 52.3094 93.9981 52.1429 93.644C51.9764 93.2898 51.9143 92.8955 51.9638 92.5072L58.3338 46.6372C58.3905 46.1476 58.626 45.6961 58.9951 45.3695C59.3642 45.0428 59.8409 44.864 60.3338 44.8672H64.7038C65.1967 44.864 65.6734 45.0428 66.0425 45.3695C66.4116 45.6961 66.6471 46.1476 66.7038 46.6372L73.0438 92.4872C73.1003 92.8756 73.0447 93.2721 72.8835 93.63C72.7223 93.9878 72.4622 94.2922 72.1338 94.5072Z",
    fill: "#00C65E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7838 28.7273H55.1638C54.8466 28.757 54.5402 28.8575 54.267 29.0213C53.9938 29.1851 53.7608 29.4081 53.5852 29.6739C53.4096 29.9397 53.2959 30.2415 53.2524 30.557C53.2089 30.8726 53.2367 31.1939 53.3338 31.4973L56.3338 43.0273C56.4289 43.4522 56.66 43.8344 56.9921 44.1159C57.3242 44.3975 57.7391 44.563 58.1738 44.5873H64.8738C65.3085 44.563 65.7234 44.3975 66.0555 44.1159C66.3875 43.8344 66.6187 43.4522 66.7138 43.0273L69.7138 31.4973C69.8122 31.1863 69.8378 30.8568 69.7887 30.5343C69.7396 30.2118 69.6171 29.9049 69.4306 29.6372C69.2441 29.3696 68.9986 29.1484 68.7131 28.9906C68.4276 28.8328 68.1096 28.7427 67.7838 28.7273V28.7273Z",
    fill: "#08A636"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5845 30.5374H57.1145C56.8376 30.5796 56.5734 30.682 56.3402 30.8372C56.1071 30.9925 55.9107 31.1968 55.7649 31.436C55.6192 31.6752 55.5275 31.9433 55.4963 32.2217C55.4651 32.5001 55.4952 32.7819 55.5845 33.0474L58.0445 43.4574C58.1024 43.8308 58.2852 44.1736 58.5631 44.4297C58.841 44.6858 59.1976 44.8401 59.5745 44.8674H65.1345C65.5103 44.8397 65.8655 44.6851 66.1417 44.4288C66.418 44.1726 66.5988 43.83 66.6545 43.4574L69.1145 33.0474C69.2038 32.7819 69.2339 32.5001 69.2028 32.2217C69.1716 31.9433 69.0799 31.6752 68.9341 31.436C68.7883 31.1968 68.592 30.9925 68.3588 30.8372C68.1257 30.682 67.8614 30.5796 67.5845 30.5374Z",
    fill: "#00C65E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.223 40.9573H57.723C56.1048 40.9573 54.793 42.2691 54.793 43.8873V45.7973C54.793 47.4155 56.1048 48.7273 57.723 48.7273H65.223C66.8412 48.7273 68.153 47.4155 68.153 45.7973V43.8873C68.153 42.2691 66.8412 40.9573 65.223 40.9573Z",
    fill: "#F89358"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8841 87.1672V88.3172H64.5741V89.9572H60.8841V91.6072H59.0641V89.9572H57.7441V88.3172H59.0641V87.1672H57.7441V85.5172H59.0641V80.0872H63.5841C64.0703 80.0683 64.5552 80.1471 65.0104 80.3189C65.4656 80.4906 65.8817 80.7519 66.2341 81.0872C66.5631 81.4151 66.8241 81.8048 67.0022 82.2338C67.1803 82.6628 67.272 83.1227 67.272 83.5872C67.272 84.0517 67.1803 84.5116 67.0022 84.9406C66.8241 85.3696 66.5631 85.7593 66.2341 86.0872C65.8817 86.4225 65.4656 86.6838 65.0104 86.8555C64.5552 87.0273 64.0703 87.1061 63.5841 87.0872L60.8841 87.1672ZM63.5841 85.5172C63.8341 85.5242 64.0829 85.4799 64.3151 85.387C64.5473 85.2942 64.758 85.1547 64.9341 84.9772C65.1149 84.803 65.2572 84.5929 65.3519 84.3604C65.4466 84.1279 65.4917 83.8781 65.4841 83.6272C65.4911 83.3772 65.4468 83.1285 65.354 82.8963C65.2611 82.6641 65.1216 82.4534 64.9441 82.2772C64.7669 82.0976 64.5549 81.9562 64.321 81.8616C64.0871 81.7671 63.8364 81.7213 63.5841 81.7272H60.8841V85.5072L63.5841 85.5172Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_19026",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_19026"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_19026"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_19026",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.c955a3489fe143aeeb16fa75d2876717.svg";
export { ForwardRef as ReactComponent };